import React from 'react';

export default function NotFound(props)
{
    return (
        <div>NOT FOUND</div>
    )
}
